export default mongoOperator => ({
  getPathExpression: (path, value, isNegated) => {
    if (isNegated) {
      return { [path.join('.')]: { $not: { [mongoOperator]: value } } };
    } else {
      return { [path.join('.')]: { [mongoOperator]: value } };
    }
  }
});
